module.exports = __webpack_public_path__ + "img/ct-en_US-img.bf153e33.png";